import type { MaterialInfo, MaterialValue } from "@rogue/rackbuilder"
import { RMLMaterialStrategy } from "../../builders/strategies/rmlMaterialStrategy"

export class FMLMaterialStrategy extends RMLMaterialStrategy {
  createFrontCrossmemberAddonMaterials(): MaterialInfo {
    const ghostMetalMaterials: MaterialValue[] = [
      { name: 'unpainted', color: 'white', config: { opacity: 0.01 } },
      { name: 'metal', material: 'mg', config: { opacity: 0.2 } },
    ]

    return {
      main     : ghostMetalMaterials,
      hardware : { config: { opacity: 0.2 } },
    }
  }
}